import { gql } from "@apollo/client";

export const ANNOUNCEMENT_BANNER_QUERY = gql`
  query AnnouncementBanner {
    announcementBanner {
      id
      message
      backgroundColor
      textColor
      updatedAt
    }
  }
`;

export const ADMIN_UPSERT_ANNOUNCEMENT_BANNER = gql`
  mutation AdminUpsertAnnouncementBanner(
    $message: String
    $backgroundColor: String
    $textColor: String
  ) {
    adminUpsertAnnouncementBanner(
      input: {
        message: $message
        backgroundColor: $backgroundColor
        textColor: $textColor
      }
    ) {
      announcementBanner {
        id
        message
        backgroundColor
        textColor
        updatedAt
      }
      errors
    }
  }
`;
